import {
  useMutation,
  UseMutationOptions,
  UseMutationResult,
} from '@tanstack/react-query';
import { MutationFetchFunction } from 'common/helpers/common';
import { ApiError, ApiResult } from 'common/repositories/common.model';

import {
  ActivityPurchaseDeleteInput,
  ActivityPurchaseModel,
  ActivityPurchaseMutationInput,
  ActivityPurchaseUpdateInput,
} from './model';

export function useCreateActivityPurchase(
  options?: UseMutationOptions<
    ApiResult<ActivityPurchaseModel>,
    ApiError,
    ActivityPurchaseMutationInput
  >,
): UseMutationResult<
  ApiResult<ActivityPurchaseModel>,
  ApiError,
  ActivityPurchaseMutationInput
> {
  return useMutation<
    ApiResult<ActivityPurchaseModel>,
    ApiError,
    ActivityPurchaseMutationInput
  >(async function (body) {
    return await MutationFetchFunction({
      url: 'activity-purchases',
      method: 'POST',
      classType: ActivityPurchaseModel,
      body,
    });
  }, options);
}

export function useUpdateActivityPurchase(
  options?: UseMutationOptions<
    ApiResult<ActivityPurchaseModel>,
    ApiError,
    ActivityPurchaseUpdateInput
  >,
): UseMutationResult<
  ApiResult<ActivityPurchaseModel>,
  ApiError,
  ActivityPurchaseUpdateInput
> {
  return useMutation<
    ApiResult<ActivityPurchaseModel>,
    ApiError,
    ActivityPurchaseUpdateInput
  >(async function (body) {
    return await MutationFetchFunction({
      url: `activity-purchases/${body.activityPurchaseId}`,
      method: 'PUT',
      classType: ActivityPurchaseModel,
      body: body.body,
    });
  }, options);
}

export function useDeleteActivityPurchase(
  options?: UseMutationOptions<
    { message: string },
    ApiError,
    ActivityPurchaseDeleteInput
  >,
): UseMutationResult<
  { message: string },
  ApiError,
  ActivityPurchaseDeleteInput
> {
  return useMutation<
    { message: string },
    ApiError,
    ActivityPurchaseDeleteInput
  >(async function (body) {
    return await MutationFetchFunction({
      url: `activity-purchases/${body.activityPurchaseId}/void`,
      method: 'PATCH',
    });
  });
}
